//values in FormData object who get excluded from local storage and prefill.
ExcludeFormIds = ["gutscheincode","$presideform","term_condition","bookingtype","terminID","kursID","nachricht"];

$(document).ready(function () {
	$( '<div id="billingarealnk" class="pb-4 bookingTypeDescription"><i class="fa fa-circle-info pe-2" aria-hidden="true"></i>Du buchst als Privatperson. Willst du als Unternehmen buchen, dann klicke einfach hier.</div>' ).insertAfter( $( "#reAdresse > .row" ) );
	$( '<div id="billingarea"></div>' ).insertAfter( $( "#billingarealnk" ) ).hide();
  $( '#re_personal').appendTo('#billingarea');
  $( '#re_steuer').appendTo('#billingarea');
  $( '#re_funktion').appendTo('#billingarea');
	$( '#re_adresse').appendTo('#billingarea');
  $( '#re_adresse').css( "display", "none" );

  // remove reAdresse section if isfree is 0
  var isFreeInput = $('input[type="hidden"][name="isfree"]');
  if (isFreeInput.val() === "1") {
    $( '#reAdresse').remove();
  }  
	
	$("#billingarealnk").click(function () {
    $("#billingarea").toggle("fast", function () {
      var txt = $("#billingarea").is(":visible")
        ? "<i class='fa fa-circle-info pe-1'' aria-hidden='true'></i>Du buchst als Unternehmen. Willst du als Privatperson buchen, dann klicke einfach hier."
        : "<i class='fa fa-circle-info pe-1'' aria-hidden='true'></i>Du buchst als Privatperson. Willst du als Unternehmen buchen, dann klicke einfach hier.";
      $("#billingarealnk").html(txt);
      
      if($('#billingarea').is(':visible')) {
        // add address hint
        $( '<div id="reAdressHint" class="pb-4"><i class="fa fa-info-circle pe-1" aria-hidden="true"></i>Abweichende Rechnungs-Adresse? Bitte hier klicken.</div>' ).insertBefore( $( "#re_adresse" ) ); 
        
        $("#reAdressHint").click(function () {
          $( this ).toggleClass( "visible" );
          $("#re_adresse").toggle("fast", function () {
            var txt = $("#re_adresse").is(":visible")
              ? '<i class="fa fa-info-circle pe-1" aria-hidden="true"></i>Doch lieber Adresse von oben verwenden? Bitte hier klicken.'
              : '<i class="fa fa-info-circle pe-1" aria-hidden="true"></i>Abweichende Rechnungs-Adresse? Bitte hier klicken.';
            $("#reAdressHint").html(txt);
          })
        }); 

        // make re_ fields required
        $('#re_firma').attr('required', true);
        $('#re_funktion').attr('required', true);
        $('#re_steuer').attr('required', true);
        //$('[id^=re_]').attr('required', true);
      } else {
        // remove address hint
        $("#reAdressHint").remove();
        // make re_ fields optional and clear values
        $('[id^=re_]').attr('required', false);
        $('[id^=re_]').val('');
      }
      
    });
  });

  $('#booking').on('submit', function(e) {
    
    e.preventDefault();
    
    if ($('#booking').validate().form()) {
      // form validate ok: disable Button, submit data
      
      let btn = document.getElementById('register-submit');
      btn.disabled = true;
      btn.innerText = 'Verarbeitung läuft...';
      
      let formData = new FormData(e.target);

      //filling local storage with formdata
      for (let pair of formData.entries()) {
          if(!ExcludeFormIds.includes(pair[0])){
            localStorage.setItem("Form-" + pair[0], pair[1]);
          }
      }

      fetch('/widgets/buchung/addBooking/', {
        method: 'POST',
        body: formData    
      }).then((response) => { 
        if(response.ok == true) {

          var formElem = document.querySelector("#booking");
          var formElemType = formElem.dataset.bookingtype;
          var myAnchor = document.getElementById("booking");
          var mySpan = document.createElement("div");
          var msgHTML = '<div class="col-12"><div class="alert alert-success"><h1 class="din-black">Wir freuen uns sehr über deine Buchung.</h1><p>Hierzu erhältst du&nbsp;in den nächsten Tagen eine Anmeldebestätigung.&nbsp;<br>Bei Fragen stehen wir dir selbstverständlich jederzeit gerne zur Verfügung.&nbsp;<br><br>Dein Akademie-Team der Maschinenringe</p><img src="/assets/img/herz-unterschrift.png" class="py-3" /></div></div>';

          if ( formElemType === 'booking.interesse' ) {
            msgHTML = '<div class="col-12"><div class="alert alert-success"><h1 class="din-black">VIELEN DANK FÜR DEIN INTERESSE AN DIESEM KURS.</h1><p>Sobald es nähere Informationen zu diesem Kurs gibt, erhältst du von uns eine E-Mail.<br><br>Dein Akademie-Team der Maschinenringe</p><img src="/assets/img/herz-unterschrift.png" class="py-3" /></div></div>';
          }

          mySpan.innerHTML = msgHTML;
          myAnchor.parentNode.replaceChild(mySpan, myAnchor);
        } else {
          var myAnchor = document.getElementById("booking");
          var mySpan = document.createElement("div");
          mySpan.innerHTML = '<div class="col-12"><div class="alert alert-success"><h1 class="din-black">Wir freuen uns sehr über deine Buchung.</h1><p>Hierzu erhältst du&nbsp;in den nächsten Tagen eine Anmeldebestätigung.&nbsp;<br>Bei Fragen stehen wir dir selbstverständlich jederzeit gerne zur Verfügung.&nbsp;<br><br>Dein Akademie-Team der Maschinenringe</p></div></div>';
          myAnchor.parentNode.replaceChild(mySpan, myAnchor);
        }
      });
     
    }
    
  })
	
});

//Array of local storage keys or formelement id's
lsKeys=[];
for(let i = 0; i< localStorage.length; i++){
  var key = localStorage.key(i);
  if(key.includes("Form-")){
    lsKeys.push(key.substring(5));
  }
}
//prefill for existing local storage Data
for(let ids of lsKeys){
  if(!ExcludeFormIds.includes(ids)){
    elem = document.querySelectorAll(`[id="${ids}"]`);
    elem.forEach(function (elem) {
      if(localStorage.getItem("Form-" + ids) && elem){
        if(elem.tagName === "INPUT" || elem.tagName === "SELECT"){
          elem.value = localStorage.getItem("Form-"+ids);
        }
      }
    });
  }
}

